import type { ISection1PreparerTranslator } from '@models/onboarding-review/section1-preparer-translator';
import {
    action,
    observable
} from 'mobx';

export interface ISection1PreparerTranslatorStore extends Readonly<ISection1PreparerTranslator> {
    setDetails(details: ISection1PreparerTranslator): void;
}

/**
 * Reactive data layer entity for preparer translator section
 */
export class Section1PreparerTranslatorStore implements ISection1PreparerTranslatorStore {
    @observable
    didUseTranslatorPreparer: boolean = false;

    @observable
    signature: string = '';

    @observable
    signedOn: string = '';

    @observable
    firstName: string = '';

    @observable
    lastName: string = '';

    @observable
    streetAddress: string = '';

    @observable
    apartmentNumber: string = '';

    @observable
    city: string = '';

    @observable
    state: string = '';

    @observable
    zipCode: string = '';

    /**
     * Updates the details of the Section 1 Preparer Translator section
     * Intended only for use by logic layer
     * @param details
     */
    @action.bound
    setDetails(details: ISection1PreparerTranslator) {
        this.didUseTranslatorPreparer = details.didUseTranslatorPreparer;
        this.signature = details.signature;
        this.firstName = details.firstName
        this.lastName = details.lastName;
        this.streetAddress = details.streetAddress;
        this.apartmentNumber = details.apartmentNumber;
        this.city = details.city;
        this.state = details.state;
        this.zipCode = details.zipCode;
        this.signedOn = details.signedOn;
    }
}



// WEBPACK FOOTER //
// ./src/stores/onboarding-review/section1-preparer-translator-store.ts